import { Button, Checkbox, Col, DatePicker, Form, Modal, Pagination, Row, Select, Table, Typography, message } from 'antd'
import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { format, formatDate, subDays } from 'date-fns';
import { MultiaxisLineChart } from 'charts/MultiaxisLineChart';
import AddGraphical from 'components/Popup/Add_Graphical';
import { getAppVersions, getCallNumbPerDay, getOrderCallNotes, get_Channels, get_call_numbs, get_dimensions, get_metrics, get_order_statuses, get_services, get_staffs } from '../../services/api.service';
import { exportTableToExcel, formatNumber, isNumber, toNumber } from 'helpers';
import checkPermissionFunction from 'Permission';
import { getDataCallHistoryReport, getCallHistoryGraphical, getDuLieuBaoCao } from 'services/callHistoryReport';
import { setAppLoading } from 'app/slices/appSlice';
import { useDispatch } from 'react-redux';
import excel from 'exceljs';

dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;

const rangePresets = [
    {
        label: '7 ngày trước',
        value: [dayjs().add(-7, 'd'), dayjs()],
    },
    {
        label: '14 ngày trước',
        value: [dayjs().add(-14, 'd'), dayjs()],
    },
    {
        label: '30 ngày trước',
        value: [dayjs().add(-30, 'd'), dayjs()],
    },
    {
        label: '90 ngày trước',
        value: [dayjs().add(-90, 'd'), dayjs()],
    },
];

const path = 'CallHistoryReport';

function CallHistoryReport() {

    // Shared
    const now = new Date();
    const [isLoading, set_isLoading] = useState(true);
    const [open, set_open] = useState(false);
    const [showModal, set_showModal] = useState(false);
    const [defaultData, set_defaultData] = useState({
        serviceTypeIds: [{ value: 1, label: "Dịch vụ 1:1" }, { value: 2, label: "Dịch vụ InApp" }]
    });
    // before applying
    const [before_data, set_before_data] = useState({
        startTime: formatDate(subDays(now, 30), "dd/MM/yyyy"),
        endTime: formatDate(now, "dd/MM/yyyy"),
        orderStatusIds: [],
        orderCallNotes: [],
        callNumbIds: [],
        serviceTypeIds: [],
        serviceIds: [],
        staffIds: [],
        callNumberPerDays: [],
    });

    // Apply
    const [current_data, set_current_data] = useState({
        startTime: formatDate(subDays(now, 30), "dd/MM/yyyy"),
        endTime: formatDate(now, "dd/MM/yyyy"),
        orderStatusIds: [],
        orderCallNotes: [],
        callNumbIds: [],
        serviceTypeIds: [],
        serviceIds: [],
        staffIds: [],
        callNumberPerDays: [],
    });

    //graphical
    const [condition, set_condition] = useState([{ metricIds: [1], dimensionIds: [] }]);
    const [data_graphical, set_graphical] = useState([]);

    // Table
    const [conditionTable, set_conditionTable] = useState({ metricIds: [1, 2], dimensionIds: [1] });
    const [colSpan, set_colSpan] = useState(conditionTable.dimensionIds.length);

    const [dataTable, set_dataTable] = useState([]);
    const [data_export, set_data_export] = useState({});

    const [columns, set_columns] = useState([]);
    const [fixedColumns, set_fixedColumns] = useState([]);

    const [form] = Form.useForm();
    const [isOpenModal, setIsOpenModal] = useState(false);

    const dispatch = useDispatch();
    useEffect(() => {
        async function Refresh() {
            dispatch(setAppLoading(true));

            const obj = Object.assign({}, defaultData);

            const dimensions = await get_dimensions(9);

            obj.dimensions = dimensions?.data?.data

            const metrics = await get_metrics(9);

            obj.metrics = metrics?.data?.data;

            const orderStatusIds = await get_order_statuses();

            obj.orderStatusIds = orderStatusIds?.data?.data?.map((item) => {
                return { label: item.name, value: item.id };
            }) ?? [];

            const orderCallNotes = await getOrderCallNotes();

            obj.orderCallNotes = orderCallNotes?.data?.data?.map((item) => {
                return { label: item.name, value: item.name };
            }) ?? [];

            const callNumbIds = await get_call_numbs();

            obj.callNumbIds = callNumbIds?.data?.data?.map((item) => {
                return { label: item.name, value: item.id };
            }) ?? [];

            const callNumberPerDays = await getCallNumbPerDay();

            obj.callNumberPerDays = callNumberPerDays?.data?.data?.map((item) => {
                return { label: item.name, value: item.id };
            }) ?? [];

            const staffIds = await get_staffs();

            obj.staffIds = staffIds?.data?.data?.map((item) => {
                return { label: item.name, value: item.id };
            }) ?? [];

            const serviceIds = await get_services();

            obj.serviceIds = serviceIds?.data?.data?.map((item) => {
                return { label: item.name, value: item.id };
            }) ?? [];

            set_defaultData(obj);

            const data_Table = await getDataCallHistoryReport(Object.assign({}, current_data, conditionTable));

            converData(data_Table?.data?.data);

            const data_graphical = await getCallHistoryGraphical(Object.assign({}, current_data, condition[0]));

            set_graphical([data_graphical?.data?.data]);
            set_isLoading(false);
            dispatch(setAppLoading(false));
        }
        Refresh();
    }, []);

    useEffect(() => {
        if (before_data.serviceTypeIds) {
            get_services(before_data.serviceTypeIds).then(result => {
                const obj = Object.assign({}, defaultData);
                obj.serviceIds = result?.data?.data?.map((item) => {
                    return { label: item.name, value: item.id };
                }) ?? [];

                set_defaultData(obj);
            });
        }
    }, [before_data.serviceTypeIds])

    function converData(data) {
        const columnstmp = Object.keys(data.statistics[0] || {}).map(key => {
            const { name, type, id } = data.statistics[0][key];
            return {
                title: name, dataIndex: name, width: 150,
                sorter: isSortable(type, id) ? (a, b) => set_sorter(a, b, name) : undefined,
            };
        });

        set_columns(columnstmp);

        let tmp = [];

        for (let i = 0; i < data.statistics.length; i++) {
            const value = data.statistics[i].reduce((acc, item) => {
                acc[item.name] = item.value;
                acc.type = item.type;
                acc.id = item.id;
                acc.key = i;
                return acc;
            }, {});
            tmp.push(value)
        }

        set_dataTable(tmp);
        set_data_export(data);
        set_fixedColumns(data.total);
    }

    function isSortable(type, id) {
        if (type == "dimension" && id != 1)
            return false;
        return true;
    }

    function set_sorter(a, b, name) {
        if (isNumber(a?.[name])) {
            return toNumber(a?.[name]) - toNumber(b?.[name]);
        }

        const regex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/(\d{4})$/;

        if (regex.test(a?.[name])) {
            const [aDay, aMonth, aYear] = a?.[name].split('/').map(Number);
            const [bDay, bMonth, bYear] = b?.[name].split('/').map(Number);
            return new Date(aYear, aMonth - 1, aDay) - new Date(bYear, bMonth - 1, bDay);
        }
        return false;
    }

    // useEffect(() => {
    //     console.log(current_time)
    // }, [current_time])

    function onOpenChange(open) {
        set_open(open);
    }

    function onCalendarChange(dates) {
        let obj = Object.assign({}, before_data);
        obj.startTime = dayjs(dates[0]).format('DD/MM/YYYY');
        obj.endTime = dayjs(dates[1]).format('DD/MM/YYYY');

        if (open == true) {
            set_before_data(obj);
        }
    }

    function onChangeField(field, value) {
        let obj = Object.assign({}, before_data);
        obj[field] = value;
        set_before_data(obj);
    }

    async function onClickAplly(length) {
        // console.log(current_time)
        dispatch(setAppLoading(true));

        let tmp = [];
        for (let i = 0; i < length; i++) {
            const data_graphical = await getCallHistoryGraphical(Object.assign({}, before_data, condition[i]));
            tmp.push(data_graphical?.data?.data);
        }
        set_graphical(tmp);
        set_current_data(before_data);

        const data_Table = await getDataCallHistoryReport(Object.assign({}, before_data, conditionTable));

        converData(data_Table?.data?.data);
        dispatch(setAppLoading(false));
    }

    async function changeDimension(id, index) {

        let obj = { ...condition[index] };

        if (id == 0) {
            obj.dimensionIds = [];

        } else {
            obj.dimensionIds = [Number(id)];
        }

        let tmp = [...condition];
        tmp[index] = obj;
        set_condition(tmp);

        const graphical = await getCallHistoryReportGraphical(Object.assign({}, current_data, obj));

        let graphicals = [...data_graphical];
        graphicals[index] = graphical?.data?.data;
        set_graphical(graphicals);
    }

    async function changeMetrics(id, index) {

        let obj = { ...condition[index] };
        obj.metricIds = [Number(id)];

        let tmp = [...condition];
        tmp[index] = obj;
        set_condition(tmp);

        const graphical = await getCallHistoryGraphical(Object.assign({}, current_data, obj));

        let graphicals = [...data_graphical];
        graphicals[index] = graphical?.data?.data;
        set_graphical(graphicals);

        // set_searchData_Graphical(obj);
    }

    async function onAddGraphical(metric, dimention) {
        dispatch(setAppLoading(true));
        let tmp = [...condition];
        tmp.push({ metricIds: [metric], dimensionIds: dimention == 0 ? [] : [dimention] });

        const graphical = await getCallHistoryGraphical(Object.assign({}, current_data, { metricIds: [metric], dimensionIds: dimention == 0 ? [] : [dimention] }));

        let graphicals = [...data_graphical];
        graphicals.push(graphical?.data?.data);
        set_graphical(graphicals);

        set_condition(tmp);
        dispatch(setAppLoading(false));
    }

    async function onChangeDimentionTable(id, status) {
        let obj = Object.assign({}, conditionTable);

        if (status == true) {
            if (!conditionTable.dimensionIds.includes(Number(id))) {
                obj.dimensionIds.push(Number(id));
            }
        } else {
            obj.dimensionIds = obj.dimensionIds.filter(item => item != Number(id));
        }

        obj.dimensionIds = obj.dimensionIds.sort();

        set_conditionTable(obj);
    }

    function onChangeMetricTable(id, status) {
        let obj = Object.assign({}, conditionTable);

        if (status == true) {
            if (!conditionTable.metricIds.includes(Number(id))) {
                obj.metricIds.push(Number(id));
            }
        } else {
            obj.metricIds = obj.metricIds.filter(item => item != Number(id));
        }

        obj.metricIds = obj.metricIds.sort();

        set_conditionTable(obj);
    }

    async function onChangeTable() {
        dispatch(setAppLoading(true));

        const data_Table = await getDataCallHistoryReport(Object.assign({}, current_data, conditionTable));

        converData(data_Table?.data?.data);

        set_colSpan(conditionTable.dimensionIds.length);
        dispatch(setAppLoading(false));
    }

    async function xuatBaoCao(fromDate, toDate) {
        dispatch(setAppLoading(true));
        try {
            const data = await getDuLieuBaoCao({ fromDate, toDate });

            const duLieuBaoCao = data?.data?.data;

            const languages = data?.data?.languages;

            let workbook = new excel.Workbook();
            // let worksheets = workbook.addWorksheet(`DATA ${}`);
            let worksheets = {};

            languages.forEach(element => {
                worksheets[element] = workbook.addWorksheet(`DATA ${element}`);
            });


            for (let i = 0; i < duLieuBaoCao.length; i++) {
                const { stageName, data } = duLieuBaoCao[i];

                Object.keys(stageName).map(key => {
                    const cellStage = worksheets[key].addRow([stageName[key] || ""]);
                    cellStage.getCell(1).font = { bold: true, size: 20 };
                })

                for (let j = 0; j < data?.length; j++) {
                    const { body, header, nameTable, group } = data[j];

                    Object.keys(nameTable).map(key => {

                        const cellName = worksheets[key].addRow([nameTable[key] || ""]);
                        cellName.getCell(1).font = { bold: true };

                        worksheets[key].addRow([]);

                        const row = worksheets[key].addRow([]);

                        let currentColumnIndex = 1;

                        group?.[key]?.forEach((element, index) => {
                            const { length, title } = element;
                            const endColumnIndex = currentColumnIndex + length - 1;

                            if (length > 1) {
                                worksheets[key].mergeCells(row.number, currentColumnIndex, row.number, endColumnIndex);
                            }

                            const cell = row.getCell(currentColumnIndex);
                            cell.value = title;
                            cell.font = { bold: true };
                            cell.alignment = { wrapText: true, horizontal: "left", vertical: "top" };
                            cell.border = {
                                top: { style: 'thin' },
                                left: { style: 'thin' },
                                bottom: { style: 'thin' },
                                right: { style: 'thin' }
                            };

                            currentColumnIndex = endColumnIndex + 1;
                        });
                    })

                    Object.keys(header).map(key => {
                        const cellHeader = worksheets[key].addRow(header[key] || []);

                        for (let z = 1; z <= cellHeader.cellCount; z++) {
                            const cell = cellHeader.getCell(z);
                            if (cell.value !== null) {
                                cell.font = { bold: true };
                                cell.alignment = { wrapText: true, horizontal: "left", vertical: "top" };
                                cell.border = {
                                    top: { style: 'thin' },
                                    left: { style: 'thin' },
                                    bottom: { style: 'thin' },
                                    right: { style: 'thin' }
                                };
                            }
                        }

                        body?.forEach(element => {
                            const row = worksheets[key].addRow(element);
                            // Set border for each cell in the row up to the last value
                            for (let z = 1; z <= row.cellCount; z++) {
                                const cell = row.getCell(z);
                                // if (cell.value !== null) { 
                                cell.alignment = { wrapText: true };
                                cell.border = {
                                    top: { style: 'thin' },
                                    left: { style: 'thin' },
                                    bottom: { style: 'thin' },
                                    right: { style: 'thin' }
                                };
                                // }
                            }
                        });

                        worksheets[key].addRow([]);
                    })
                }

                // worksheet.addRow([]);
            }

            // Use exceljs to write the workbook to a file
            workbook.xlsx
                .writeBuffer()
                .then((buffer) => {
                    let blob = new Blob([buffer], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${"baocao"}.xlsx`; // Tên file muốn lưu
                    document.body.appendChild(a);
                    a.click();
                    a.remove(); // Sau khi tải về, xóa element a khỏi DOM
                })
                .catch((error) => {
                    console.error('Error writing file:', error);
                });
        } catch (error) {
            console.log(error);
            const errData = error?.response?.data || {};
            const msg = errData?.showMessage || errData?.message || "Có lỗi xảy ra";
            message.error(msg);
        } finally {
            dispatch(setAppLoading(false));
            setIsOpenModal(false);
        }

    }


    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current > dayjs().endOf('day') || current < dayjs().subtract(7, "days");
    };

    return (
        <div className="container-fluid">
            <Modal
                open={isOpenModal}
                title={<div className='flex items-center justify-center'>
                    <Typography.Title level={4}>Chọn khoảng thời gian xuất</Typography.Title>
                </div>}
                onCancel={() => { setIsOpenModal(false) }}
                onClose={() => { setIsOpenModal(false) }}
                onOk={() => {
                    form.submit();
                }}
            >
                <Form
                    onFinish={(values) => {
                        const { fromDate, toDate } = values;

                        xuatBaoCao(dayjs(fromDate).format("YYYY-MM-DD"), dayjs(toDate).format("YYYY-MM-DD"))
                    }}
                    form={form}
                    initialValues={{
                        fromDate: dayjs(formatDate(now, "yyyy/MM/dd")),
                        toDate: dayjs(formatDate(now, "yyyy/MM/dd")),
                    }}
                >
                    <Row justify="space-between">
                        <Col span={11}>
                            <Form.Item
                                rules={[{ required: true }]}
                                name="fromDate"
                            >
                                <DatePicker
                                    className='w-full'
                                    placeholder='Ngày bắt đầu'
                                    format="DD/MM/YYYY"
                                // disabledDate={disabledDate}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={11}>
                            <Form.Item
                                name="toDate"
                                rules={[{ required: true }]}
                            >
                                <DatePicker
                                    className='w-full'
                                    placeholder='Ngày kết thúc'
                                    format="DD/MM/YYYY"
                                // disabledDate={disabledDate}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
            {
                showModal && <AddGraphical
                    dimensions={defaultData?.dimensions}
                    metrics={defaultData?.metrics}
                    onClose={() => set_showModal(false)}
                    onChange={onAddGraphical}
                />
            }
            {
                isLoading == false && <div className="card card-body flex gap-3">
                    <div className='flex'>
                        <div className='w-full'>
                            <h1><b>THỐNG KÊ LỊCH SỬ CUỘC GỌI</b></h1>
                        </div>
                        <div className='w-full flex justify-content-end gap-3'>
                            <Button
                                type='primary'
                                onClick={() => {
                                    // xuatBaoCao();
                                    setIsOpenModal(true);
                                }}
                            >
                                Export báo cáo Kbank
                            </Button>
                            <Button type="primary"
                                onClick={() => {
                                    checkPermissionFunction(path, 'export', () =>
                                        exportTableToExcel(data_export, colSpan, "LICHSUCUOCGOI")
                                    );

                                }}
                            >Export</Button>
                            <Button type="primary"
                                onClick={() => set_showModal(true)}
                            >Thêm biểu đồ</Button>
                        </div>
                    </div>

                    <div className="flex gap-3">
                        <Row justify="space-between" gutter={[20, 20]}>
                            <Col>
                                <div>
                                    <b>Khoảng thời gian</b>
                                </div>
                                <RangePicker
                                    presets={rangePresets}
                                    onOpenChange={onOpenChange}
                                    onCalendarChange={(dates) => onCalendarChange(dates)}
                                    placeholder={['Thời gian bắt đầu', 'Thời gian kết thúc']}
                                    defaultValue={[dayjs(formatDate(subDays(now, 30), "yyyy/MM/dd")), dayjs(formatDate(now, "yyyy/MM/dd")),]}
                                    format="DD/MM/YYYY"
                                    style={{
                                        width: "300px"
                                    }}
                                />
                            </Col>
                            <Col>
                                <div>
                                    <b>Trạng thái</b>
                                </div>
                                <Select
                                    style={{ width: "300px", maxWidth: "500px" }}
                                    options={defaultData?.orderStatusIds ?? []}
                                    mode='multiple'
                                    onChange={(value) => {
                                        onChangeField("orderStatusIds", value)
                                        // set_current_rate(e);
                                    }}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </Col>
                            <Col>
                                <div>
                                    <b>Phân loại lý do</b>
                                </div>
                                <Select
                                    style={{ width: "300px", maxWidth: "500px" }}
                                    options={defaultData?.orderCallNotes ?? []}
                                    mode='multiple'
                                    onChange={(value) => {
                                        onChangeField("orderCallNotes", value)
                                        // set_current_rate(e);
                                    }}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </Col>
                            <Col>
                                <div>
                                    <b>Lần gọi</b>
                                </div>
                                <Select
                                    style={{ width: "300px", maxWidth: "500px" }}
                                    options={defaultData?.callNumbIds ?? []}
                                    mode='multiple'
                                    onChange={(value) => {
                                        onChangeField("callNumbIds", value)
                                        // set_current_rate(e);
                                    }}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </Col>
                            <Col>
                                <div>
                                    <b>Loại dịch vụ</b>
                                </div>
                                <Select
                                    style={{ width: "300px", maxWidth: "500px" }}
                                    options={defaultData?.serviceTypeIds ?? []}
                                    mode='multiple'
                                    onChange={(value) => {
                                        onChangeField("serviceTypeIds", value)
                                        // set_current_rate(e);
                                    }}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </Col>
                            <Col>
                                <div>
                                    <b>Dịch vụ</b>
                                </div>
                                <Select
                                    style={{ width: "300px", maxWidth: "500px" }}
                                    options={defaultData?.serviceIds ?? []}
                                    mode='multiple'
                                    onChange={(value) => {
                                        onChangeField("serviceIds", value)
                                        // set_current_rate(e);
                                    }}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </Col>
                            <Col>
                                <div>
                                    <b>Nhân viên</b>
                                </div>
                                <Select
                                    style={{ width: "300px", maxWidth: "500px" }}
                                    options={defaultData?.staffIds ?? []}
                                    mode='multiple'
                                    onChange={(value) => {
                                        onChangeField("staffIds", value)
                                        // set_current_rate(e);
                                    }}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </Col>
                            <Col>
                                <div>
                                    <b>Số cuộc gọi trong ngày</b>
                                </div>
                                <Select
                                    style={{ width: "300px", maxWidth: "500px" }}
                                    options={defaultData?.callNumberPerDays ?? []}
                                    mode='multiple'
                                    onChange={(value) => {
                                        onChangeField("callNumberPerDays", value)
                                        // set_current_rate(e);
                                    }}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </Col>
                            <Col className='content-end'>
                                <div style={{ width: "300px", maxWidth: "500px" }}>
                                    <Button type="primary"
                                        onClick={() => onClickAplly(data_graphical.length)}
                                    >Áp dụng</Button>
                                </div>
                            </Col>
                            <Col>
                                <div style={{ width: "300px" }}></div>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <Row className='pt-5'>
                            {
                                data_graphical.map((item, index) => {
                                    return <Col
                                        key={index}
                                        xs={24}    // Chiếm toàn bộ chiều rộng trên màn hình nhỏ
                                        sm={24}    // Chiếm 1/2 chiều rộng trên màn hình nhỏ hơn
                                        md={(index === data_graphical.length - 1 && data_graphical.length % 2 === 1) ? 24 : 12} // Điều chỉnh kích thước trên màn hình vừa và lớn hơn
                                        lg={(index === data_graphical.length - 1 && data_graphical.length % 2 === 1) ? 24 : 12}   // Chiếm 1/2 chiều rộng trên màn hình lớn hơn
                                        xl={(index === data_graphical.length - 1 && data_graphical.length % 2 === 1) ? 24 : 12}    // Chiếm 1/2 chiều rộng trên màn hình rất lớn
                                        className={`${index != data_graphical.length ? "pb-5" : ""}`}
                                    >
                                        <div>
                                            <div className='flex gap-3 flex-wrap align-content-center'>
                                                <div className='flex gap-2'>
                                                    <b className='align-content-center'>Metrics</b>
                                                    <Select
                                                        defaultValue={defaultData?.metrics.find(item => item.id == condition[index].metricIds[0])?.name}
                                                        options={defaultData?.metrics.map((item) => {
                                                            return { label: item.name, value: item.id };
                                                        })}
                                                        style={{ width: "200px" }}
                                                        onChange={(e) => changeMetrics(e, index)}
                                                    />
                                                </div>
                                                <div className='flex gap-2'>
                                                    <b className='align-content-center'>Dimension</b>
                                                    <Select
                                                        defaultValue={defaultData?.dimensions.find(item => item.id == condition[index].dimensionIds[0])?.name || "Tất cả"}
                                                        options={[{ label: "Tất cả", value: 0 }, ...defaultData?.dimensions.filter((item) => (item.id != 1 && item.id != 9)).map((item) => {
                                                            return { label: item.name, value: item.id };
                                                        })]}
                                                        style={{ width: "200px" }}
                                                        onChange={(e) => changeDimension(e, index)}
                                                    />
                                                </div>
                                                {
                                                    index != 0 && <Button danger onClick={() => {
                                                        const tmp = [...data_graphical.slice(0, index), ...data_graphical.slice(index + 1)];
                                                        const tmpcondiotion = [...condition.slice(0, index), ...condition.slice(index + 1)];

                                                        set_condition(tmpcondiotion);
                                                        set_graphical(tmp);
                                                    }}>Xoá</Button>
                                                }
                                            </div>
                                            <MultiaxisLineChart Unprocessed_Data={item} unit="" />
                                            <div
                                                className="row mx-n2 text-center mt-2 overflow-auto"
                                                style={{ maxHeight: '20em' }}
                                            >
                                                {item &&
                                                    item.total &&
                                                    item.total.map((item1, index1) => {
                                                        return (
                                                            <span key={index1} className="col-12 col-sm-6 col-md-4 px-2">
                                                                <span>
                                                                    {item1.name}: {`${formatNumber(item1?.value)} ${item?.unit ?? ""}`}                                                                </span>
                                                            </span>
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    </Col>
                                })
                            }
                        </Row>
                    </div>
                    <div>

                        <Row>
                            <Col
                                xs={24}
                                sm={24}
                                md={24}
                                lg={20}
                                xl={20}
                            >
                                <Table columns={columns}
                                    dataSource={dataTable}
                                    // pagination={false}
                                    pagination={true}
                                    scroll={{ x: 'max-content', y: 500 }}
                                    summary={() => (
                                        <Table.Summary fixed>
                                            <Table.Summary.Row>
                                                <Table.Summary.Cell index={0} colSpan={colSpan}><b>Tổng</b></Table.Summary.Cell>
                                                {
                                                    fixedColumns.map((item, index) => {
                                                        return (
                                                            <Table.Summary.Cell key={index} index={index + 1}>{item.value}</Table.Summary.Cell>
                                                        )
                                                    })
                                                }
                                            </Table.Summary.Row>
                                        </Table.Summary>
                                    )}
                                />

                            </Col>
                            <Col
                                xs={12}
                                sm={12}
                                md={12}
                                lg={4}
                                xl={4}
                                className='bg-gray-100'
                            >
                                <div className='flex flex-col justify-between container-fluid pt-3 pb-3'>
                                    <b>Dimension</b>
                                    {
                                        defaultData?.dimensions?.map((item, index) => {
                                            return (
                                                <div key={index} className='col d-flex align-items-center gap-2'>
                                                    <Checkbox
                                                        onClick={(e) => onChangeDimentionTable(item.id, e.target.checked)}
                                                        defaultChecked={conditionTable.dimensionIds.includes(Number(item.id))}
                                                    >
                                                        {item.name}
                                                    </Checkbox>
                                                </div>
                                            )
                                        })
                                    }
                                    <b>Metrics</b>
                                    {
                                        defaultData?.metrics?.map((item, index) => {
                                            return (
                                                <div key={index} className='col d-flex align-items-center gap-2'>
                                                    <Checkbox
                                                        onClick={(e) => onChangeMetricTable(item.id, e.target.checked)}
                                                        defaultChecked={conditionTable.metricIds.includes(Number(item.id))}
                                                    >
                                                        {item.name}
                                                    </Checkbox>
                                                </div>
                                            )
                                        })
                                    }
                                    <div className='pt-5 text-center'>
                                        <Button type="primary"
                                            disabled={(conditionTable.dimensionIds.length == 0 || conditionTable.metricIds.length == 0) ? true : false}
                                            onClick={() => {
                                                onChangeTable()
                                            }}
                                        >Áp dụng</Button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <div className="col-2" style={{ alignItems: 'center' }}>

                        </div>
                    </div>
                </div>
            }
        </div >
    )
}

export default CallHistoryReport;